module.exports = __webpack_public_path__ + "media/promo/hochland/images/bg_3-b6f12379ef0ae65bee97146a5d5d661c.png";